import { render, staticRenderFns } from "./PartnerBanner.vue?vue&type=template&id=2823303e&scoped=true&"
import script from "./PartnerBanner.vue?vue&type=script&lang=js&"
export * from "./PartnerBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823303e",
  null
  
)

export default component.exports